import React from "react";
import CustomButton from "./CustomButton";
import { useTabletMediaQuery, useMobileMediaQuery } from '../utils';
import '../css/suspendedWalletAlert.css';


const SuspendedWalletAlert = (props) => {

    const isTablet = useTabletMediaQuery();
    const isMobile = useMobileMediaQuery();

    return (
        <div className={ isTablet ? 'doYouHaveSuspendedWalletMainViewSuspendedWalletAlert' : ( isMobile ? 'doYouHaveSuspendedWalletMainViewSuspendedWalletAlertTablet' : 'doYouHaveSuspendedWalletMainViewSuspendedWalletAlertMobile' )}>
            <div className={ isTablet ? 'doYouHaveSuspendedWalletSuspendedWalletAlert' : ( isMobile ? 'doYouHaveSuspendedWalletSuspendedWalletAlertTablet' : 'doYouHaveSuspendedWalletSuspendedWalletAlertMobile') }>
                <div className={ isTablet ? 'txtDoYouHaveSuspendedWalletSuspendedWalletAlertContainer' : (isMobile ? 'txtDoYouHaveSuspendedWalletSuspendedWalletAlertContainer' : 'txtDoYouHaveSuspendedWalletSuspendedWalletAlertContainerMobile')}>
                    <div className={ isTablet ? 'txtBoldDoYouHaveSuspendedWalletSuspendedWalletAlert' : 'txtBoldDoYouHaveSuspendedWalletSuspendedWalletAlertMobile' }>A sua carteira encontra-se suspensa</div>
                    <div className='txtRegularDoYouHaveSuspendedWalletSuspendedWalletAlert'>Decidimos suspender a sua carteira por suspeitas de atividade fraudulenta. Entre em contacto para resolver a sua situação.</div>
                </div>
                <div className={ isTablet ? 'divBtnGoToContactsSuspendedWalletSuspendedWalletAlert' : ( isMobile ? 'divBtnGoToContactsSuspendedWalletSuspendedWalletAlertTablet' : 'divBtnGoToContactsSuspendedWalletSuspendedWalletAlertMobile') }>
                    <CustomButton 
                        text={'Entrar em contacto'} 
                        color={'#fff'}
                        textColor={'#141414'}
                        hasShadowWithe
                        onPress={props.onPress} 
                    />
                </div>
            </div>
        </div>
    );
};

export default SuspendedWalletAlert;